module.exports = __webpack_public_path__ + "img/wordmark-white.87f0e4b5.png";